// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Navbar language dropdown — INCYIA */

.incyia-lang {
  position: relative;
  font-family: Lato, sans-serif;
}

.incyia-lang-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 10px 0 11px;
  border-radius: 9px;
  border: 1px solid #dee4f0;
  background: #fff;
  color: #0b1e2d;
  font-family: Lato, sans-serif;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0.04em;
  cursor: pointer;
  width: auto !important;
  transition: background 0.14s, border-color 0.14s, color 0.14s;
}

.incyia-lang-trigger:hover {
  background: #f7f9fd;
  border-color: #c5d0e0;
}

.incyia-lang-trigger.is-open {
  background: #f7f9fd;
  border-color: #0d9b87;
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.12);
}

.incyia-lang-globe {
  color: #076b5c;
  flex-shrink: 0;
}

.incyia-lang-code {
  line-height: 1;
}

.incyia-lang-caret {
  color: #8a9ba7;
  transition: transform 0.18s ease;
  margin-left: -2px;
}

.incyia-lang-trigger.is-open .incyia-lang-caret {
  transform: rotate(180deg);
  color: #076b5c;
}

.incyia-lang-menu {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 1400;
  min-width: 196px;
  padding: 6px;
  background: #fff;
  border: 1px solid #dee4f0;
  border-radius: 12px;
  box-shadow:
    0 1px 2px rgba(6, 21, 36, 0.04),
    0 16px 40px -20px rgba(0, 20, 109, 0.4);
  animation: incyia-lang-in 0.16s ease;
}

.incyia-lang-menu-label {
  padding: 6px 10px 8px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8b99b4;
}

.incyia-lang-option {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100% !important;
  margin: 0;
  padding: 9px 10px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #0b1e2d;
  font-family: Lato, sans-serif;
  text-align: left;
  cursor: pointer;
  transition: background 0.12s;
}

.incyia-lang-option:hover {
  background: #f7f9fd;
}

.incyia-lang-option.is-active {
  background: #e2f7f2;
}

.incyia-lang-option-short {
  width: 32px;
  height: 24px;
  border-radius: 6px;
  display: grid;
  place-items: center;
  background: #eaeff7;
  color: #00146d;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  flex-shrink: 0;
}

.incyia-lang-option.is-active .incyia-lang-option-short {
  background: #0d9b87;
  color: #fff;
}

.incyia-lang-option-name {
  flex: 1 1;
  font-size: 13.5px;
  font-weight: 600;
  line-height: 1.2;
}

.incyia-lang-check {
  color: #076b5c;
  flex-shrink: 0;
}

.incyia-lang-check-slot {
  width: 16px;
  flex-shrink: 0;
}

@keyframes incyia-lang-in {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/langSelector.css"],"names":[],"mappings":"AAAA,sCAAsC;;AAEtC;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB;;2CAEyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["/* Navbar language dropdown — INCYIA */\n\n.incyia-lang {\n  position: relative;\n  font-family: Lato, sans-serif;\n}\n\n.incyia-lang-trigger {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 10px 0 11px;\n  border-radius: 9px;\n  border: 1px solid #dee4f0;\n  background: #fff;\n  color: #0b1e2d;\n  font-family: Lato, sans-serif;\n  font-size: 14px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  cursor: pointer;\n  width: auto !important;\n  transition: background 0.14s, border-color 0.14s, color 0.14s;\n}\n\n.incyia-lang-trigger:hover {\n  background: #f7f9fd;\n  border-color: #c5d0e0;\n}\n\n.incyia-lang-trigger.is-open {\n  background: #f7f9fd;\n  border-color: #0d9b87;\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.12);\n}\n\n.incyia-lang-globe {\n  color: #076b5c;\n  flex-shrink: 0;\n}\n\n.incyia-lang-code {\n  line-height: 1;\n}\n\n.incyia-lang-caret {\n  color: #8a9ba7;\n  transition: transform 0.18s ease;\n  margin-left: -2px;\n}\n\n.incyia-lang-trigger.is-open .incyia-lang-caret {\n  transform: rotate(180deg);\n  color: #076b5c;\n}\n\n.incyia-lang-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  z-index: 1400;\n  min-width: 196px;\n  padding: 6px;\n  background: #fff;\n  border: 1px solid #dee4f0;\n  border-radius: 12px;\n  box-shadow:\n    0 1px 2px rgba(6, 21, 36, 0.04),\n    0 16px 40px -20px rgba(0, 20, 109, 0.4);\n  animation: incyia-lang-in 0.16s ease;\n}\n\n.incyia-lang-menu-label {\n  padding: 6px 10px 8px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #8b99b4;\n}\n\n.incyia-lang-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100% !important;\n  margin: 0;\n  padding: 9px 10px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #0b1e2d;\n  font-family: Lato, sans-serif;\n  text-align: left;\n  cursor: pointer;\n  transition: background 0.12s;\n}\n\n.incyia-lang-option:hover {\n  background: #f7f9fd;\n}\n\n.incyia-lang-option.is-active {\n  background: #e2f7f2;\n}\n\n.incyia-lang-option-short {\n  width: 32px;\n  height: 24px;\n  border-radius: 6px;\n  display: grid;\n  place-items: center;\n  background: #eaeff7;\n  color: #00146d;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  flex-shrink: 0;\n}\n\n.incyia-lang-option.is-active .incyia-lang-option-short {\n  background: #0d9b87;\n  color: #fff;\n}\n\n.incyia-lang-option-name {\n  flex: 1;\n  font-size: 13.5px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.incyia-lang-check {\n  color: #076b5c;\n  flex-shrink: 0;\n}\n\n.incyia-lang-check-slot {\n  width: 16px;\n  flex-shrink: 0;\n}\n\n@keyframes incyia-lang-in {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
